import './style.scss';
const close = require('../../../../../../assets/clear-button.svg') as string;

type Props = {
  title: string;
  subtitle: string;
  toggleChat: () => void;
  closeChat: () => void;
  showCloseButton: boolean;
  titleAvatar?: string;
}

function Header({ title, subtitle, toggleChat, closeChat, showCloseButton, titleAvatar }: Props) {
  return (
    <div className="rcw-header">
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingRight: '10px' }}>
        <button className="rcw-minimize-button" onClick={toggleChat}>
          <img src={close} className="rcw-minimize" alt="minimize" />
        </button>
        <button className="rcw-close-button" onClick={closeChat==null?toggleChat:closeChat}>
          <img src={close} className="rcw-close" alt="close" />
        </button>
      </div>
      <h4 className="rcw-title">
        {titleAvatar && <img src={titleAvatar} className="avatar" alt="profile" />}
        {title}
      </h4>
      <span>{subtitle}</span>
    </div>
  );
}

export default Header;
